import { isProdLike } from "@imi/utils/env.js";
import * as Sentry from "@sentry/react";

if (isProdLike(import.meta.env.VITE_ENVIRONMENT)) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.replayIntegration()],
    // Session Replay
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
  });
}
